import { useState } from 'react';
import { Box, Button } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { MedicareInsuranceEntry } from '../entries';
import { MedicareFormShape } from '../hooks/useMedicareForm';
import { ConfirmationModal } from '@components';

interface IMedicareInsuranceListProps {
  patient_id: string;
  onDelete: () => Promise<void>;
  onSubmit: () => Promise<boolean>;
}

export const MedicareInsuranceList = ({
  patient_id,
  onDelete,
  onSubmit,
}: IMedicareInsuranceListProps) => {
  const {
    watch,
    formState: { isDirty, isValid, isSubmitting },
  } = useFormContext<MedicareFormShape>();
  const isPersisted = !!watch('entry.id');

  const [isConfirmOpen, setIsConfirmOpen] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  const handleClick = () => {
    setIsConfirmOpen(true);
  };

  const handleConfirm = async () => {
    setIsDeleting(true);
    try {
      await onDelete();
    } finally {
      setIsDeleting(false);
      setIsConfirmOpen(false);
    }
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <MedicareInsuranceEntry patient_id={patient_id} />
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Button
          variant='contained'
          color='secondary'
          onClick={onSubmit}
          disabled={!isDirty || !isValid || isSubmitting}
          loading={isSubmitting}
          loadingPosition='start'
          sx={{ color: 'white' }}
        >
          {isSubmitting ? 'Saving...' : 'Save'}
        </Button>
        <Button
          variant='text'
          color='error'
          onClick={handleClick}
          disabled={!isPersisted || isSubmitting}
          sx={{ px: 0 }}
        >
          Delete
        </Button>
      </Box>

      <ConfirmationModal
        isOpen={isConfirmOpen}
        title='Delete insurance'
        message='Are you sure you want to delete this insurance entry?'
        confirmText='Delete'
        isLoading={isDeleting}
        onConfirm={handleConfirm}
        onClose={() => setIsConfirmOpen(false)}
      />
    </Box>
  );
};
